import { ArrowLeftRightIcon } from 'lucide-react';
import type { PropsWithChildren } from 'react';
import { useHostedAuthSession } from '../../../hooks/useHostedAuthSession';
import { useProvider } from '../../../hooks/useProvider';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../shadcn/Card';

type Props = {
  title: string;
  description: string | React.ReactNode;
};

export function WizardStepContainer({ title, description, children }: PropsWithChildren<Props>) {
  const { data: session } = useHostedAuthSession();

  if (!session) return null;

  return (
    <WizardStepWrapper brand_icon_url={session.brand_icon_url} title={title} description={description}>
      {children}
    </WizardStepWrapper>
  );
}

export function WizardStepWrapper({
  children,
  brand_icon_url,
  title,
  description,
}: PropsWithChildren<Props & { brand_icon_url: string | undefined }>) {
  const { provider_icon, provider_name } = useProvider();

  return (
    <Card className="w-full">
      <CardHeader className="text-center">
        <div className="mb-2 flex items-center justify-center gap-4">
          <img src={provider_icon} alt={provider_name} className="h-10 w-10 rounded-md" />
          {brand_icon_url && (
            <>
              <ArrowLeftRightIcon className="text-muted-foreground" />
              <img alt="logo" className="h-10 w-10 object-contain" src={brand_icon_url} />
            </>
          )}
        </div>

        <CardTitle>{title}</CardTitle>
        <CardDescription>{description}</CardDescription>
      </CardHeader>

      <CardContent className="pt-6">{children}</CardContent>
    </Card>
  );
}
